import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 96 96"
    }, props), {
        children: /*#__PURE__*/ _jsx("image", {
            href: "/images/logo.png",
            width: "96px"
        })
    }));
};
export default Icon;
